import { get_sequential_diff } from "../../lib/misc/array";
import { Maybe } from "../../lib/misc/option";
import { BaseActionWithNav } from "./BaseActionWithNav";
class ResultTable {
    constructor(columns, data) {
        this.strapToDataMap = new Map();
        this.columns = columns;
        this.data = data;
        let strapIndex = this.gis_strap_index;
        if (strapIndex == -1) {
            strapIndex = this.strap_index;
        }
        data.forEach(row => {
            const value = this.get_strap_value(strapIndex, row);
            this.strapToDataMap.set(value, row);
        });
    }
    get_strap_value(index, row) {
        let value = row[index];
        if (!value) {
            value = row[this.strap_index];
        }
        return value;
    }
    get strap_index() {
        let col = this.columns.find(c => c.displayName.toLowerCase() === "strap");
        return col ? parseInt(col.name) : -1;
    }
    get gis_strap_index() {
        let col = this.columns.find(c => c.displayName.toLowerCase() === "gis_strap");
        return col ? parseInt(col.name) : -1;
    }
    get ids() {
        let strapIndex = this.gis_strap_index;
        if (strapIndex === -1) {
            strapIndex = this.strap_index;
        }
        return this.data.map(row => this.get_strap_value(strapIndex, row));
    }
    get_data_for(strap) {
        let schema = {};
        this.columns.filter(c => c.visible).forEach(col => schema[col.displayName] = null);
        const row = this.strapToDataMap.get(strap);
        if (!row)
            return schema;
        for (const col of Object.keys(schema)) {
            const column = this.columns.find(c => c.displayName === col);
            if (column.name !== null) {
                schema[col] = row[parseInt(column.name)];
            }
        }
        return schema;
    }
}
export class AddParcelsAction extends BaseActionWithNav {
    constructor(layer) {
        super('ADD PARCELS');
        this.layer = layer;
        this.exit_ctx = '';
    }
    validate(message) {
        return super.validate(message) && typeof message.table === 'string' && message.table.length > 0;
    }
    on_valid_message() { }
    async singleton_ctx_handler(focused, ids) {
        this.layer.clear();
        if (ids.length === 0)
            return;
        await this.layer.add_features_by_ids(ids, focused);
    }
    async set_ctx_handler(focused, ids) {
        if (ids.length === 0)
            return;
        let diff = get_sequential_diff(this.layer.features.map(f => f.get(this.layer.identifier)), ids);
        await this.layer.add_features_by_ids(diff.adds, focused);
        this.layer.remove_features_by_ids(diff.subs);
        if (this.layer.ids.includes(focused))
            this.layer.clicked = focused;
    }
    async group_ctx_handler(focused, ids) {
        this.layer.clear();
        if (ids.length === 0)
            return;
        await this.layer.add_features_by_ids(ids, focused);
    }
    async interpret(message) {
        const entry_ctx = this.ctx();
        let resultObj = JSON.parse(message.table);
        let resultTable = new ResultTable(resultObj.columns, resultObj.data);
        let ids = resultTable.ids;
        switch (entry_ctx.map(c => c.name).unwrapOr('')) {
            case 'group':
                this.exit_ctx = '';
                break;
            default:
                this.exit_ctx = 'set';
                break;
        }
        if (ids.length === 0)
            return;
        if (!message.focused && !ids.includes(this.layer.clicked))
            message.focused = ids[0];
        else if (!message.focused)
            message.focused = this.layer.clicked;
        switch (entry_ctx.map(c => c.name).unwrapOr('')) {
            case 'singleton':
                await this.singleton_ctx_handler(message.focused, ids);
                break;
            case 'group':
                await this.group_ctx_handler(message.focused, ids);
                break;
            default:
                await this.set_ctx_handler(message.focused, ids);
                break;
        }
        for (let parcel of this.layer.features) {
            const strap = parcel.get(this.layer.identifier);
            const record = resultTable.get_data_for(strap);
            for (let key in record)
                parcel.set(key, record[key]);
        }
        if (this.layer.colorized) {
            this.layer.colorize_current_parcels();
            this.layer.color_manager.populate_legend();
        }
    }
    reset() {
        this.exit_ctx = '';
    }
    after_valid_message() {
        let ret_val = {
            zoom: true,
            center: false,
            context: this.exit_ctx,
            fail: false,
            navigate: Maybe(this.layer.clicked)
        };
        this.reset();
        return ret_val;
    }
}
